/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('resort.summer-overview')
 */
import { GetServerSideProps } from 'next';
import { Routes } from 'routes';
import { RESORTS_WITH_SUMMER_GUIDE_PAGE } from 'ots-constants';
import { assertShouldBeNot404, NotFoundError } from 'util/wrapProps';
import { getResortSlug } from 'util/memcache';
import { getLocale } from 'i18n/locale';
import { ResortLayout } from 'page-components/resort/_layout';
import Component, { getSummerOverviewPageServerSideProps, SummerOverviewPageProps } from 'page-components/resort/summer-overview';
import { propsWithI18NSSR } from 'util/propsWithI18n';

export default Object.assign(Component, { Layout: ResortLayout });

type ResortPageParams = { region: string; resort: string };

const guardSummerOverviewAccess: GetServerSideProps<SummerOverviewPageProps, ResortPageParams> = async (context) => {
  const resortParam = context.params?.resort;

  if (typeof resortParam !== 'string') {
    return { notFound: true };
  }

  let pathInfoResponse;
  try {
    pathInfoResponse = await assertShouldBeNot404(() => getResortSlug(resortParam));
  } catch (error) {
    if (error instanceof NotFoundError) {
      return { notFound: true };
    }
    throw error;
  }
  const pathInfo = pathInfoResponse.data;
  const locale = getLocale();

  const hasSummerGuide = RESORTS_WITH_SUMMER_GUIDE_PAGE.some(
    (item) => item.locale === locale && item.resortId === pathInfo.uuid,
  );

  if (!hasSummerGuide) {
    return {
      redirect: {
        destination: Routes.resortTripPlanningOverview(pathInfo),
        permanent: false,
      },
    };
  }

  return getSummerOverviewPageServerSideProps(context);
};

export const getServerSideProps = propsWithI18NSSR(guardSummerOverviewAccess);
